

















































































































































































































































































































































































































































































import Vue from "vue";
import Component from "vue-class-component";
import { Store } from "vuex";
import { State } from "vuex-class";
import config from "../services/api-config";
import "@/directives/directives";
import AuthService from "../services/auth-service";
import { GeneralService } from "../services/general-service";
import "@/styles/navbar.scss";
import EmojiRating from "./EmojiRating.vue";
import moment from "moment";

@Component({
  name: "area-navigation",
  components: {
    EmojiRating,
  },
  methods: {},
})
export default class AreaNavigation extends Vue {
  private connectionString =
    "Endpoint=sb://pgcelqueue.servicebus.windows.net/;SharedAccessKeyName=elmessagequeue;SharedAccessKey=yLkFZNdB03H0wdNkQGhxtNHw7HlHoZRj3yPjpvXHlJY=;EntityPath=elmessagequeue";
  private queueName = "elmessagequeue";
  private auth = new AuthService();
  private isAuth = this.auth.isAuthenticated();
  private selected: any = [];
  private startSurvey = false;
  private text: any = "";
  private isPre = false;
  private isPre2 = false;
  private color = "#E03C28";
  private collapse = true;
  private isFB = false;
  private isProf = false;
  private notRead = 0;
  private notif = {};
  private isHadaf = false;
  private surveyTeachers: any = [];
  private surveyRating: any = [];
  private surveyHeading: any = "";
  private surveySelected: any = {};
  private surveyRemarks: string = "";
  private surveyExpired = false;
  private surveyNumber = 0;
  private surveyError = "";
  private todaySurvey = false;
  private surveyModal: any = {};
  private isSurveyMandatory = false;
  private surveyQuestions: any = [];
  private admissionID: any = "";
  private surveyID: any = "";
  private errorMandatory = "";
  private isImage = true;

  private service = new GeneralService();

  private messages: any = [];
  private readmore: any = [];

  checkImage(src: string) {
    let type = src.substring(src.length - 3, src.length);

    if (type.toLowerCase() == "jpg" || type.toLowerCase() == "png") {
      this.isImage = true;
    } else {
      this.isImage = false;
    }
  }

  downloadFile(link: string) {
    window.open(link, "_blank");
  }

  getState(index, course) {
    if (this.selected[index] && this.selected[index][course]) {
      return this.selected[index][course].length <= 241
    }
    else return null
  }

  openExpired(survey) {
    this.surveyExpired = false;
    this.todaySurvey = true;
    this.$bvModal.show("survey");
    this.surveyHeading = survey.notificationObject.title;
  }

  submitSurvey() {
    this.surveyError = "";

    for (
      let i = 0;
      i < this.surveySelected.notificationObject.data.length;
      i++
    ) {
      this.surveySelected.notificationObject.data[i].rating =
        this.surveyRating[i];
      if (!this.surveyRating[i] || this.surveyRating[i] == 0) {
        this.surveyError = "Kindly rate all of the teachers before submitting.";
        return;
      }
    }

    this.service
      .pushSurvey(
        this.auth.session.userName.split("@")[0],
        this.surveyRemarks,
        this.surveySelected.notificationObject
      )
      .then((response) => {
        this.$bvModal.hide("survey");
        localStorage[config.todaySurvey] = moment().format("YYYY-MM-DD");
        window.location.reload();
      });
  }

  parseOptions(options) {
    let parsedO = this.parser(options);
    let returnArray: any = [];

    for (let i = 0; i < parsedO.length; i++) {
      returnArray.push({ text: parsedO[i].option, value: parsedO[i].option });
    }
    return returnArray;
  }

  beforeCreated() {
    if (this.$route.path === "/") {
      this.color = "transparent";
    }
  }

  testPaper() {
    window.location.href = "/testclassselect";
  }

  private goNotice() {
    (this.$refs.popover as any).$emit("close");
    this.$router.push("/noticeboard");
  }

  closeModal() {
    this.$bvModal.hide("image");
  }

  openSurvey(survey) {
    let details = survey.notificationObject;
    this.surveyRating = [];
    this.surveyTeachers = details.data;
    this.surveyHeading = details.notification;
    this.surveySelected = survey;
    let today = moment().format("YYYY-MM-DD");
    this.surveyExpired = false;
    // if (today !== details.expiry) this.surveyExpired = true;
    this.$bvModal.show("survey");
  }

  goToType(notif) {
    let type = notif.notificationObject.type;
    let image = notif.notificationObject.image;

    (this.$refs.popover as any).$emit("close");
    if (type == "Attendence") this.$router.push("/attend");
    else if (type == "Fee") this.$router.push("/fees");
    else if (type == "Examination") this.$router.push("/examresult");
    else if (type == "Survey") {
      this.openSurvey(notif);
    } else if (type == "Survey Form") {
      this.openExpired(notif);
    } else {
      this.notif = notif.notificationObject;
      this.$bvModal.show("image");
      this.checkImage(notif.notificationObject.image);
    }
  }

  navbarBgChange() {
    const navbar = document.getElementById("navbar");

    if (
      navbar &&
      (!navbar.classList.contains("navbar-d") ||
        navbar.classList.contains("home"))
    ) {
      const el = navbar;
      if (el !== null) {
        if (window.scrollY > 50) {
          el.setAttribute(
            "style",
            "background-color: rgba(44, 62, 80," +
            Math.min(window.scrollY / 500, 0.9) +
            ") !important"
          );
        } else {
          el.setAttribute("style", this.color);
        }
      }
    } else if (navbar && navbar.classList.contains("navbar-d")) {
      navbar.setAttribute("style", this.color);
    }
  }

  private switchApp() {
    if (this.isPre) {
      localStorage[config.isPre] = null;
      this.$router.push("/selectApp");
    } else {
      localStorage[config.isPre] = true;
    }

    window.location.reload();
  }

  private switchPre() {
    if (this.isPre2) {
      localStorage[config.isPre2] = null;
    } else {
      localStorage[config.isPre2] = true;
    }
    localStorage[config.classLevl] = null;
    window.location.reload();
  }

  private setTimestamp() {
    let last = -1000;
    this.notRead = 0;
    for (let i = 0; i < this.messages.length; i++) {
      last = Math.max(
        parseInt(moment(this.messages[i].fromDate).format("x")),
        last
      );
    }
    localStorage[config.notificationLast] = last;
  }

  private cancelSurvey = false;

  showSurvey(data) {
    this.surveyModal = data;
    if (data.attempted == "true") {
      this.openExpired(data)
      return
    }
    if (data.mandatory == "true") this.isSurveyMandatory = true;
    else this.isSurveyMandatory = false;
    let username = this.auth.session.userName.split("@")[0];
    
    this.service.getInfoEMS(username).then((userdata) => {
      let currentData: any = userdata.data[0];
      for (let i = 0; i < userdata.data.length; i++) {
        if (userdata.data[i].Class.indexOf("II") > -1)
          currentData = userdata.data[i];
      }
      this.admissionID = currentData.Admission_Form_ID;
      this.service
        .getMandatorySurvey(
          currentData.Admission_Form_ID,
          currentData.Class_Level_ID,
          data.id
        )
        .then((response) => {
          this.surveyQuestions = response.data;
          this.selected = [];
          for (let i = 0; i < this.surveyQuestions.length; i++) {
            if (
              i == 0 &&
              (!this.surveyQuestions[i].coursesName ||
                this.surveyQuestions[i].coursesName == "") && (this.surveyQuestions[i].query !== 'General')
            ) {
              this.cancelSurvey = true;
            }
            if (
              !this.surveyQuestions[i].coursesName ||
              this.surveyQuestions[i].coursesName == ""
            ) {
              this.selected[i] = null;
            } else {
              this.selected[i] = [];
              let courses = this.parser(this.surveyQuestions[i].coursesName);
              for (let j = 0; j < courses.length; j++) {
                this.selected[i][courses[j].CourseName] = null;
              }
            }
          }
          if (!this.cancelSurvey) this.$bvModal.show("surveyMandatory");
          else this.$bvModal.show("error-popup");
        });
    });
  }

  private urlify(text) {
    var urlRegex = /(https?:\/\/[^\s]+)/g;
    return text.replace(urlRegex, function (url) {
      return '<a target="_blank" href="' + url + '">' + url + "</a>";
    });
  }

  private testData() {
    let returnData: any = [];
    this.errorMandatory = "";

    for (let i = 0; i < this.selected.length; i++) {
      if (this.selected[i] == null && i !== this.selected.length - 1) {
        this.errorMandatory =
          "Please complete all the questions first. Missing answer for Q" +
          (i + 1);
        return;
      }
      if (typeof this.selected[i] == "object") {
        for (const course in this.selected[i]) {
          if (this.selected[i][course] == null) {
            this.errorMandatory =
              "Please complete all the questions first. Missing answer for Q" +
              (i + 1) +
              " and field " +
              course;
            return;
          }
          returnData.push({
            surveydetailid: this.surveyQuestions[i].surveyDetailId,
            coursename: course,
            option: this.selected[i][course] ?? 1,
          });
        }
      } else {
        returnData.push({
          surveydetailid: this.surveyQuestions[i].surveyDetailId,
          coursename: "",
          option: this.selected[i],
        });
      }
    }

    this.service
      .insertMandatorySurvey(this.admissionID, this.surveyModal.id, returnData)
      .then((response) => {
        this.$bvModal.hide("surveyMandatory");
      });
  }

  formattedDate(date) {
    return moment(date).format("DD-MM-YYYY");
  }

  getMessages(limit) {
    this.readmore = [];
    let today = moment().format("YYYY-MM-DD");
    this.service
      .getNotifications(
        this.auth.session.userName.split("@")[0].toUpperCase(),
        limit
      )
      .then((response) => {
        for (let i = 0; i < response.data.length; i++) {
          this.readmore.push(false);
        }
        this.messages = response.data;
        this.notRead = 0;
        this.surveyNumber = 0;
        for (let message of this.messages) {
          message.notificationObject = JSON.parse(message.notificationObject);
          if (
            message.notificationObject.type !== "Survey" &&
            message.notificationObject.type !== "Survey Form"
          )
            this.notRead++;
          else if (message.notificationObject.type == "Survey Form")
            if (
              message.notificationObject.attempted == "false" &&
              moment(today).isBetween(
                moment(message.notificationObject.fromDate).subtract(1, "hour"),
                moment(message.notificationObject.toDate).add(1, "hour")
              )
            ) {
              this.showSurvey(message.notificationObject);
            } else {
              this.surveyNumber++;
            }
        }
      });
  }

  updateRead(i) {
    Vue.set(this.readmore, i, true);
  }

  logout() {
    this.auth.logout();
  }

  // beforeMount () {
  //   window.addEventListener('scroll', this.navbarBgChange);
  // }

  beforeDestroy() {
    window.removeEventListener("scroll", this.navbarBgChange);
  }

  // parser = (e) => JSON.parse(e);

  parser = (e) => {
    try {
      var k;
      if (e.length > 0) {
        k = JSON.parse(e);
      }
    } catch (error) {
      console.error("Error parsing JSON:", error);
      // Optionally, you can throw the error or return a default value
      throw error; // or return a default value, e.g., return {};
    }
    finally {
      return k;
    }
  };

  mounted() {
    let origin = window.location.origin;
    if (origin.toLowerCase().indexOf("hadaf") > -1) this.isHadaf = true;

    let today = moment().format("YYYY-MM-DD");

    if (localStorage[config.todaySurvey] == today) {
      this.todaySurvey = true;
    }

    const button = document.getElementById("toggleColor");
    const state = localStorage[config.buttonState];
    if (this.auth.session) {
      let username = this.auth.session.userName;
      this.isProf =
        /^prof/.test(username.toLowerCase()) ||
        /^principal/.test(username.toLowerCase()) ||
        username.toLowerCase() === "khaqan.ghani@pgc.edu.pk";
    }

    if (localStorage[config.isPre]) {
      this.isPre = JSON.parse(localStorage[config.isPre]);
    }

    if (
      localStorage[config.isPre2] &&
      localStorage[config.isPre2] !== "undefined"
    )
      this.isPre2 = JSON.parse(localStorage[config.isPre2]);
    if (this.auth.session) this.getMessages(80);

    if (this.auth.session && this.auth.session.userName == "facebook@pgc.edu") {
      this.isFB = true;
    }

    if (button !== null) {
      if (state == "light-theme") {
        button.className = "fas fa-circle";
      }
    }
  }
}
